import { render, staticRenderFns } from "./reporteNotasCriticas.vue?vue&type=template&id=1370bca9&scoped=true&"
import script from "./reporteNotasCriticas.vue?vue&type=script&lang=js&"
export * from "./reporteNotasCriticas.vue?vue&type=script&lang=js&"
import style0 from "./reporteNotasCriticas.vue?vue&type=style&index=0&id=1370bca9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370bca9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VCol,VDataTable,VIcon,VRow,VTextField,VTooltip})
